import { TimelineMax, Power3 } from "gsap";
import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { Text } from "pixi.js";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { TranslationConfig } from "../../../translations/TranslationConfig";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class TextHandler extends BaseView {

    protected value:number = 729;
    protected waysText:string = "Ways";

    protected _textCounter:Text;
    protected _timeLine:TimelineMax;

    private readonly DEFAULT_TEXT_STYLE:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontSize : 84,
        fontWeight : FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFFFFF",
        lineJoin: "round",
        stroke: "#FF2600",
        strokeThickness: 8
    };

    public get textObj():Text{
        return this._textCounter;
    }

    constructor (){
        super();
        this.initAnimations();
    }

    protected initAnimations():void{
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);
        this.waysText = Translation.translate(TranslationConfig.BANNER_WAYS);
        this._textCounter = this.createTextObject();
        this.alpha = 0;
    }

    public changeText(val:string):void{
        this._textCounter.text = val;
    }

    protected createTextObject():Text{
        const textObj = new Text(this.waysText);
        textObj.style = this.DEFAULT_TEXT_STYLE;
        textObj.anchor.set(0.5,0.5);
        this.addChild(textObj);
        return textObj;
    }

    public show(duration:number):void{
        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax());
        this._timeLine.fromTo(this, duration,{alpha:0}, {alpha:1, ease:Power3.easeOut},0);
        this._timeLine.fromTo(this.scale, duration*0.7,{x:0.4,y:0.4}, {x:1.1,y:1.1, ease:Power3.easeOut},0);
        this._timeLine.to(this.scale, duration*0.3, {x:1,y:1},duration*0.7);
        this._timeLine.play();
    }
}